"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeEVMImportTransaction = exports.estimateEVMImportTransaction = exports.executeEVMExportTransaction = exports.estimateEVMExportTransaction = void 0;
const juneo_1 = require("../../../juneo");
const transaction_1 = require("../../../transaction");
const utils_1 = require("../../../utils");
const constants_1 = require("../constants");
const evm_1 = require("../evm");
const fee_1 = require("../fee");
async function estimateEVMExportTransaction(api, assetId, destination) {
    const gasLimit = (0, utils_1.estimateAtomicExportGas)(api.chain.assetId, [assetId], destination.assetId);
    const baseFee = await (0, evm_1.estimateEVMBaseFee)(api);
    // the evm export fee is paid in gas so it must be multiplied by the atomic denominator
    const fee = (0, utils_1.calculateAtomicCost)(gasLimit, baseFee) * utils_1.AtomicDenomination;
    return new fee_1.BaseFeeData(api.chain, fee, juneo_1.TransactionType.Export);
}
exports.estimateEVMExportTransaction = estimateEVMExportTransaction;
async function executeEVMExportTransaction(provider, api, wallet, destination, assetId, amount, address, sendImportFee, importFee, fee) {
    // exportations of the gas token must be divided by atomic denomination
    if (assetId === api.chain.assetId) {
        amount /= utils_1.AtomicDenomination;
    }
    // fee is also gas token
    const feeAmount = fee.amount / utils_1.AtomicDenomination;
    const exportAddress = wallet.getWallet(destination).getJuneoAddress();
    const evmWallet = wallet.getJEVMWallet(api.chain);
    let nonce = await (0, evm_1.getWalletNonce)(evmWallet, api, false);
    for (let i = 0; i < constants_1.MaxInvalidNonceAttempts; i++) {
        const unsignedTransaction = (0, transaction_1.buildJEVMExportTransaction)([new transaction_1.UserInput(assetId, api.chain, amount, [address], 1, destination)], wallet.getAddress(api.chain), nonce, exportAddress, feeAmount, sendImportFee ? importFee : BigInt(0), provider.mcn.id);
        const signedTx = await unsignedTransaction.signTransaction([wallet.getWallet(api.chain)]);
        const transactionId = await api
            .issueTx(signedTx)
            .then((response) => {
            return response.txID;
        })
            .catch((error) => {
            const errorMessage = error.message;
            if (errorMessage.includes('nonce') || errorMessage.includes('replacement transaction underpriced')) {
                return undefined;
            }
            // Non nonce related error decrement nonce to avoid resyncing later.
            evmWallet.nonce--;
            throw error;
        });
        if (typeof transactionId === 'string') {
            return transactionId;
        }
        await utils_1.TimeUtils.sleep(constants_1.InvalidNonceRetryDelay);
        nonce = await (0, evm_1.getWalletNonce)(evmWallet, api, true);
    }
    throw new utils_1.TransactionError(`could not provide a valid nonce ${evmWallet.nonce}`);
}
exports.executeEVMExportTransaction = executeEVMExportTransaction;
async function estimateEVMImportTransaction(api, inputsCount, outputsCount) {
    const gasLimit = (0, utils_1.estimateAtomicImportGas)(inputsCount, outputsCount);
    const baseFee = await (0, evm_1.estimateEVMBaseFee)(api);
    const fee = new fee_1.BaseFeeData(api.chain, (0, utils_1.calculateAtomicCost)(gasLimit, baseFee), juneo_1.TransactionType.Import);
    // import fee is paid with utxos from shared memory so using JNT asset
    fee.asset = api.chain.asset.nativeAsset;
    return fee;
}
exports.estimateEVMImportTransaction = estimateEVMImportTransaction;
async function executeEVMImportTransaction(provider, api, wallet, source, fee, utxoSet) {
    const chainWallet = wallet.getWallet(api.chain);
    const sender = chainWallet.getJuneoAddress();
    const values = (0, utils_1.getUtxosAmountValues)(utxoSet, source.id);
    const inputs = (0, utils_1.getImportUserInputs)(values, fee.assetId, fee.amount, source, api.chain, wallet.getAddress(api.chain));
    const transaction = (0, transaction_1.buildJEVMImportTransaction)(inputs, utxoSet, [new transaction_1.Address(sender)], fee.amount, provider.mcn.id);
    const signedTx = await transaction.signTransaction([chainWallet]);
    return (await api.issueTx(signedTx)).txID;
}
exports.executeEVMImportTransaction = executeEVMImportTransaction;
